import React from 'react'
import GolfTemplate from 'src/components/page/golf'
import { leagueGroupIds } from 'src/constants/personalizationIds'
import { promoCodes } from 'src/constants/promoCodes'
import styled from 'styled-components'

export default (props) => (
  <StyledContainer>
    <GolfTemplate
      noindex={true}
      location={props.location}
      poster={'https://assets-imgx.fubo.tv/marketing/lp/images/posters/golf_Web_v3.png'}
      posterMobile={'https://assets-imgx.fubo.tv/marketing/lp/images/posters/golf_Mobile_v3.jpg'}
      title={
        <>
          Fubo has the <span className="desktop-line-break">most golf</span>
        </>
      }
      subtitle={'Stream 120+ live events from the PGA Tour & more'}
      matchtickerLeagueId={leagueGroupIds.golf}
      offerBanner={{
        title: ['Special offer activated.', 'Enjoy $30 off your first 2 months!'],
      }}
      offerCode={promoCodes['18birdies-offer']}
      logo={'https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-18birdies.png'}
      logoHeight={'70px'}
    />
  </StyledContainer>
)

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 645px;
  }
`
